export const MANAGE_GAME_EVENTS = 34;

//filters
export const FILTER_EVENTS = 'eventTypes';
export const FILTER_APPLICATIONS = 'appIds';

export const FILTERS = 'filters';
export const SEARCH_QUERY = 'searchQuery';
export const TABLE_SETTINGS = 'tableSettings';

// columns
export const COLUMN_APPLICATION = 'application';
export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_EVENT_TRIGGER = 'eventTrigger';
export const COLUMN_PERIOD = 'period';
export const COLUMN_PURCHASE_DATA = 'purchaseData';
export const COLUMN_REASON_CODE = 'reasonCode';
export const COLUMN_GG_EVENT = 'ggEventName';
export const COLUMN_UPDATED_DATE = 'lastUpdated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';

export const DEPENDENCIES = {
  [FILTER_EVENTS]: [FILTER_APPLICATIONS],
};

//actions
export const ACTION_EDIT = 'Edit';
export const ACTION_SHARE_WITH_AF = 'Share with AF';

export const permission = 83;
export const id = 1072;

export const COMMON_EVENT_SOURCE_ID = 0;
